export default {
  es: 'es',
};
